import { Component, ViewChild, AfterViewInit, OnInit, ElementRef, Inject, ChangeDetectionStrategy, ChangeDetectorRef, DoCheck } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CancelTestAbComponent } from "./cancel-test-ab/cancel-test-ab.component";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FlowsService } from '../../flows.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-create-ab-test',
  templateUrl: './create-ab-test.component.html',
  styleUrl: './create-ab-test.component.scss'
})
export class CreateAbTestComponent implements OnInit {

  isLive = false; //TESTE - retirar

  model: any = {}
  max = 100;
  min = 0;
  showTicks = false;
  step = 1;
  thumbLabel = false;
  value = 0;
  percentage = 0;
  flow_version_a_percentage = 0;
  flow_version_b_percentage = 0;
  flow_version_control_percentage = 0;
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private flowService: FlowsService,
    private dialogRef: MatDialogRef<CreateAbTestComponent>,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.model.open = true;

    this.model.partner = this.data.partner;
    this.model.account = this.data.account;
    this.model.flow_version = this.data.flow_version;
    this.model.selector_test = this.data.selector_test;
    this.model.snapshot_id = this.data.snapshot_id;
    this.model.is_viewer = this.data.is_ab;
    this.model.action = this.data.action;
    this.model.canCancelTestAB = this.data.canCancelTestAB;

    this.isLive = this.model.action != 'create';

    if (this.model.selector_test) {
      if (this.model.selector_test.start_date) {
        var start = moment();
        var end = moment(this.model.selector_test.start_date);
        this.model.selector_test.days_running = moment.duration(start.diff(end)).asDays().toFixed(0);
      }
    }

    if (this.model.action != 'create') {
      this.form = this.fb.group({
        titleA: [{ value: this.model.flow_version?.flows_descriptor[1].name, disabled: true }, [Validators.required, Validators.minLength(5), Validators.maxLength(32)]],
        descriptionA: [{ value: this.model.flow_version?.flows_descriptor[1].description, disabled: true }, [Validators.required]],
        titleB: [{ value: this.model.flow_version?.flows_descriptor[2].name, disabled: false }, [Validators.required, Validators.minLength(5), Validators.maxLength(32)]],
        descriptionB: [{ value: this.model.flow_version?.flows_descriptor[2].description, disabled: false }, [Validators.required]],
        percentage: [{ value: 2, disabled: false }, [Validators.required, Validators.maxLength(3), Validators.max(100), Validators.min(0)]]
      });

      this.flow_version_a_percentage = this.model.selector_test?.selector_test_flows[1].percentage;
      this.flow_version_b_percentage = this.model.selector_test?.selector_test_flows[2].percentage;

      this.form.get("percentage").setValue(this.model.selector_test?.selector_test_flows[0] != null ? (this.flow_version_a_percentage + this.flow_version_b_percentage) : 100);

      this.flow_version_control_percentage = this.model.selector_test?.selector_test_flows[0].percentage;

    } else {

      var name = this.model.flow_version?.flows_descriptor ? this.model.flow_version?.flows_descriptor[0].name : this.model.selector_test?.selector_test_flows[0].name;

      this.form = this.fb.group({
        titleA: [{ value: name, disabled: true }, [Validators.required, Validators.minLength(5), Validators.maxLength(32)]],
        descriptionA: [{ value: "Esta é uma cópia do Fluxo de Controle " + name, disabled: true }, [Validators.required, Validators.maxLength(255)]],
        titleB: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(32)]],
        descriptionB: ['', [Validators.required, Validators.maxLength(255)]],
        percentage: [{ value: 10 }, [Validators.required, Validators.maxLength(3), Validators.max(100), Validators.min(0)]]
      });

      this.form.get("percentage").setValue(10);

      this.flow_version_a_percentage = Math.floor(10 / 2);
      this.flow_version_b_percentage = Math.floor(10 / 2);
      this.flow_version_control_percentage = 100 - (this.flow_version_a_percentage + this.flow_version_b_percentage);

    }
  }

  cancelTestAb() {
    if (this.model) {

      const dialog = this.dialog.open(CancelTestAbComponent, {
        width: '990px !important',
        autoFocus: true,
        data: {
          partner: this.model.partner,
          account: this.model.account,
          snapshot_id: this.model.snapshot_id,
          selector_test: this.model.selector_test,
          flow_version: this.model.flow_version
        }
      });
      dialog.afterClosed().subscribe((response) => {

        if (response.isBack) {
          this.dialogRef.close({ reload: false });
        }

      });

    }
  }

  change(event) {
    this.form.get("percentage").setValue(event.target.value);

    this.flow_version_a_percentage = Math.floor(event.target.value / 2);
    this.flow_version_b_percentage = Math.floor(event.target.value / 2);
    this.flow_version_control_percentage = 100 - (this.flow_version_a_percentage + this.flow_version_b_percentage);

  }

  close() {
    this.dialogRef.close({ reload: false });
  }

  saveTestAb() {
    if (this.form.valid) {

      let params = {
        snapshot_id: this.model.snapshot_id,
        selector_test_id: this.model.selector_test.id,
        percentage: this.form.get("percentage").value,
        order_control: this.model.selector_test.selector_test_flows[0].order,
        name_a: this.form.get("titleA").value,
        name_b: this.form.get("titleB").value,
        description_a: this.form.get("descriptionA").value,
        description_b: this.form.get("descriptionB").value,
      };

      console.log(params);

      this.flowService.changeTestAB(this.model.partner, this.model.account, params)
        .subscribe(
          {
            next: (response) => {

              this.toastr.success(this.translateService.instant('flows.manageAbTest.action.success'));
              this.dialogRef.close({ reload: true });

              // const start = moment().format('YYYY-MM-DD');
              // const end = moment().format('YYYY-MM-DD');

              // var orders = this.model.selector_test.selector_test_flows.map(p => p.order).join(",");
              // console.log(orders);

              // this.router.navigate([
              //   this.model.partner,
              //   this.model.account,
              //   'snapshot',
              //   this.model.snapshot_id,
              //   'flow',
              //   this.model.selector_test.id,
              //   this.model.selector_test.selector_test_flows[0].flow_id,
              //   this.model.selector_test.selector_test_flows[0].version,
              //   this.model.selector_test.selector_test_flows[0].order, start, end, orders]);
              // // this.dialogRef.close({ reload: true });

            },
            error: (error) => {
            }
          });

    }
  }

  createTestAb() {
    if (this.form.valid) {

      let params = {
        snapshot_id: this.model.snapshot_id,
        selector_test_id: this.model.selector_test.id,
        flow_id: this.model.flow_version.flow_id,
        version: this.model.flow_version.version,
        percentage: this.form.get("percentage").value,
        name_a: this.form.get("titleA").value,
        name_b: this.form.get("titleB").value,
        description_a: this.form.get("descriptionA").value,
        description_b: this.form.get("descriptionB").value,
      };

      this.flowService.createTestAB(this.model.partner, this.model.account, params)
        .subscribe(
          {
            next: (response) => {
              console.log(response);

              this.dialogRef.close();
              this.toastr.success(this.translateService.instant('flows.createAbTest.action.success'));

              const start = moment().format('YYYY-MM-DD');
              const end = moment().format('YYYY-MM-DD');

              this.router.navigate([this.model.partner, this.model.account, 'snapshot', response.selector_id, 'flow', response.selector_test_id, response.flow_id, response.version, response.order_id, start, end, response.orders]);

            },
            error: (error) => {
            }
          });

    }
  }
}
